import * as types from './../constants/actionTypes';

const initialState = { };

 const prepaidCardReduser = (state = initialState, action) => {

    switch(action.type){
        case types.REFILL_PREPAID_CARD_SUCCESSFUL:
            return {
                ...state
            };
        case types.REFILL_PREPAID_CARD_FAILED:
            return {
                ...state
            };
        default:
            return state;
    }

}; 

export default prepaidCardReduser;



// WEBPACK FOOTER //
// ./src/reducers/prepaidCardReducer.js